export const getOSFullName = (slug: string) => {
    switch (slug) {
        case 'windows-server-2019':
            return 'Windows Server 2019';
        case 'windows-server-2022':
            return 'Windows Server 2022';
        case 'win-2012-r2': {
            return 'Windows Server 2012 R2';
        }
        case 'win-2016': {
            return 'Windows Server 2016';
        }
        case 'win-2019': {
            return 'Windows Server 2019';
        }
        case 'win-2022': {
            return 'Windows Server 2022';
        }
        case 'win-2025': {
            return 'Windows Server 2025';
        }
        case 'ubuntu-20-04-lts': {
            return 'Ubuntu 20.04 LTS';
        }
        case 'ubuntu-18-04-lts': {
            return 'Ubuntu 18.04 LTS';
        }
        case 'ubuntu-22-04': {
            return 'Ubuntu 22.04';
        }
        case 'ubuntu-22-04-lts': {
            return 'Ubuntu 22.04 LTS';
        }
        case 'ubuntu-24-04-lts': {
            return 'Ubuntu 24.04 LTS';
        }
        case 'ubuntu-26-04-lts': {
            return 'Ubuntu 26.04 LTS';
        }
        case 'centos-8-stream': {
            return 'CentOS 8 Stream';
        }
        case 'centos-8-3': {
            return 'CentOS 8.3';
        }
        case 'centos-8-4': {
            return 'CentOS 8.4';
        }
        case 'centos-7': {
            return 'CentOS 7';
        }
        case 'debian-11': {
            return 'Debian 11 (Bullseye)';
        }
        case 'debian-12': {
            return 'Debian 12 (Bookworm)';
        }
        case 'debian-13': {
            return 'Debian 13 (Trixie)';
        }
        case 'rocky-linux-8-10': {
            return 'Rocky Linux 8.10';
        }
        case 'rocky-linux-9-6': {
            return 'Rocky Linux 9.6';
        }
        case 'rocky-linux-10': {
            return 'Rocky Linux 10';
        }
        case 'alma-linux-9-6': {
            return 'AlmaLinux 9.6';
        }
        case 'alma-linux-8-10': {
            return 'AlmaLinux 8.10';
        }
        default: {
            return slug;
        }
    }
};
